<template>
  <div class="header">
    <app-nav-tabs :data-tabs="tabs"
                  v-model="value">
      <div slot="heading">
        {{dataHeading}}
      </div>

      <div slot="controls"
           class="controls">

        <i class="mdi mdi-content-save-outline"
           :class="{'cursor-wait': loading}"
           v-tooltip="tooltip"></i>

        <div class="text-bold">
          {{loading ? $t('message.campaigns.message.saving') : $t('message.campaigns.message.saved')}}
        </div>

        <app-preview ref="preview"
                     :data-advertising-id="advertisingId"
                     :is-desktop="isDesktopPreview"></app-preview>

        <div class="controls-previews">
          <v-icon class="controls-previews-item"
                  size="20"
                  slot="activator"
                  v-tooltip="$t('message.campaigns.message.previewMobile')"
                  @click="openMobilePreview">mdi-play
          </v-icon>

          <svgicon class="controls-previews-item"
                   icon="television-play"
                   width="20"
                   height="20"
                   slot="activator"
                   color="gray"
                   v-tooltip="$t('message.campaigns.message.previewDesktop')"
                   @click="openDesktopPreview"></svgicon>
        </div>

      </div>
    </app-nav-tabs>
  </div>
</template>

<script>
import AppNavTabs from "@components/NavTabs";
import AppPreview from "@views/advertising/components/preview/Preview";

export default {
  components: {
    AppNavTabs,
    AppPreview,
  },

  props: {
    dataHeading: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      isDesktopPreview: false,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading !== 0;
    },

    tabs() {
      return [
        {
          label: this.$t("message.campaigns.message.design"),
          value: "DESIGN",
        },
        {
          label: this.$t("message.campaigns.message.connection"),
          value: "LINK",
        },
      ];
    },

    value: {
      get() {
        return this.$store.state.interactions.tab;
      },

      set(tab) {
        this.$store.commit("INTERACTIONS_SET_TAB", tab);
      },
    },

    tooltip() {
      return this.loading
        ? "Salvando as alterações"
        : "Todas as alterações foram salvas";
    },

    advertisingId() {
      return Number(this.$route.params.id);
    },
  },

  methods: {
    openDesktopPreview() {
      this.isDesktopPreview = true;
      this.$refs.preview.start();
    },

    openMobilePreview() {
      this.isDesktopPreview = false;
      this.$refs.preview.start();
    },
  },

  mounted() {
    this.value = this.tabs[0];
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.header {
  width: calc(100% - 150px);
  grid-area: header;

  .controls {
    display: flex;
    align-items: center;
    color: $grey-4;

    .mdi {
      font-size: 26px;
      padding: 0 10px;

      &:last-child {
        padding: 0 30px 0 10px;
      }
    }

    .controls-previews {
      display: flex;
      margin-left: 10px;

      .controls-previews-item {
        cursor: pointer;
      }
    }
  }
}
</style>
